// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/integrations.actions.go

import { type Scope } from "~/hooks/useScope";
import { CREATE } from "./action";

export function canCreate(scope: Scope): boolean {
  return scope.iamActions.includes(CREATE);
}
